import { createFeatureSelector, createSelector } from '@ngrx/store';

import { filterReducerKey, InboxFilterState } from './filter-inbox.reducer';

export const selectFilter = createFeatureSelector<InboxFilterState>(filterReducerKey);

export const getLoadFavorite = createSelector(
  selectFilter, (state: InboxFilterState) => state.loadFavorite,
);

export const getStatus = createSelector(selectFilter, (state: InboxFilterState) => state.status);
